import React, { ChangeEventHandler, memo } from 'react'
import { TextInput, TextInputIconType } from 'components/atoms'
import { ISpotBiddingConfigsFilterState } from '../types/spotBiddingConfig'

interface ISpotBiddingConfigFilterProps {
  filters: ISpotBiddingConfigsFilterState
  updateConfigFilters: (search: Partial<ISpotBiddingConfigsFilterState>) => void
}

export const SpotBiddingConfigFilter = memo<ISpotBiddingConfigFilterProps>(
  ({ filters, updateConfigFilters }) => {
    const { configName = '', shipperName = '' } = filters

    const filterHandler = (key: string, value: string) =>
      updateConfigFilters({
        ...filters,
        [key]: value,
      })

    const segmentFilterHandler: ChangeEventHandler<HTMLInputElement> = ({ target: { value } }) => {
      filterHandler('configName', value)
    }
    const shipperFilterHandler: ChangeEventHandler<HTMLInputElement> = ({ target: { value } }) => {
      filterHandler('shipperName', value)
    }

    return (
      <div className='row'>
        <div className='col-xs-12 col-md-4 col-lg-3'>
          <TextInput
            value={configName}
            onChange={segmentFilterHandler}
            clearable
            large
            label='Shipper Segment'
            placeholder='Search by Shipper Segment'
            dataTest='config-name-filter'
            icon={TextInputIconType.people}
          />
        </div>
        <div className='col-xs-12 col-md-4 col-lg-3'>
          <TextInput
            value={shipperName}
            onChange={shipperFilterHandler}
            clearable
            large
            label='Shipper Name'
            placeholder='Search by Shipper'
            dataTest='shipper-name-filter'
            icon={TextInputIconType.search}
          />
        </div>
      </div>
    )
  }
)
